import { render, staticRenderFns } from "./EditDiscount.vue?vue&type=template&id=0552f682"
import script from "./EditDiscount.vue?vue&type=script&lang=js"
export * from "./EditDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports